import React from 'react';
//import { Text } from 'react-native';
//import logo from './logo.svg';
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar'; 
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Container } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import logoknbb from './knbblogo.png';
import { BrowserRouter as Router, Route , Switch } from "react-router-dom";
import Standloader5Pins from "./Standloader5Pins";
import Standloader5Pinszonderwedstrijden from "./Standloader5Pinszonderwedstrijden"
import StandloaderBiatlon from "./StandloaderBiatlon";
import Speelschema from "./Speelschema"
import Ranglijst5Pins from "./Ranglijst5Pins"
import RanglijstBiatlon from "./RanglijstBiatlon"
import Eindetoernooi from "./Eindetoernooi"
import { Link } from "react-router-dom";
import { AutoLogin } from './firestore';
import Scoreboardloadertafels58 from './ScoreboardLoadertafels58';
import ScoreboardLoader from './ScoreboardLoader';
import Stand from "./Stand"
import testlinks from './testlinks'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

function App () {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    //alert(event.currentTarget)
  };

  const handleClose = () => {
    setAnchorEl(null);
   // alert(item)
  };
  
  AutoLogin()
  
  
  return (

  //   <div align="center">
  //     <Toolbar>
  //       <Paper style={{padding: 25, marginTop: 50, backgroundColor: "steelblue", color: "white"}}>
  //     <Typography variant="h6" className={classes.title} >
  //            NK 5Pins en Biatlon 2019 zijn voorbij. 
  //          </Typography>
  //          <Typography variant="h6" className={classes.title}>
  //          De definitieve resultaten worden eerdaags gepubliceerd.
  //          </Typography>
  //          <Typography variant="subtitle2" style={{align: "flex-end", marginTop: 20}}>Beverwijk, 28 oktober Pierre de Boer</Typography>
  //          </Paper>
  //     </Toolbar>
  // </div>
  //   <div align="center">
  //     <Toolbar>
  //       <Paper style={{padding: 25, marginTop: 50, backgroundColor: "steelblue", color: "white"}}>
  //     <Typography variant="h6" className={classes.title} >
  //            NK 5Pins 2021 Live scores. 
  //          </Typography>
  //          <Typography variant="h6" className={classes.title}>
  //         Klik in het menu om de acturle scores te zien of de ranglijsten.
  //          </Typography>
  //          <Typography variant="subtitle2" style={{align: "flex-end", marginTop: 20}}>Beverwijk, oktober 2021  Pierre de Boer</Typography>
  //          </Paper>
  //     </Toolbar>
  // </div>
    
    <div className="App">
       <Router>
      <AppBar position="static">
     
        <Toolbar>
          {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton> */}
           <img
            src={logoknbb}
            style={{ width: 60, padding: 5 }}
            alt="Logo KNBB"
          />
          <Typography variant="h6" className={classes.title}>
            NK Biatlon 12 - 13 februari te Sittard
          </Typography>
          <Button color="inherit" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        Menu
      </Button>
          <Menu
        id="scsimple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* <MenuItem onClick={handleClose}><Link to="/">Livescores</Link></MenuItem> */}
        {/* <MenuItem onClick={handleClose}><Link to="/">Eindetoernooi</Link></MenuItem> */}
        <MenuItem onClick={handleClose}><Link to="/Stand5Pinszonderwedstrijden">Stand poules</Link></MenuItem>
        {/* <MenuItem onClick={handleClose}><Link to="/Stand5Pins">5Pins scores</Link></MenuItem> */}
        {/* <MenuItem onClick={handleClose}><Link to="/StandBiatlon">Biatlon scores</Link></MenuItem>
        */}
        {/* <MenuItem onClick={handleClose}><Link to="/StandBiatlon">Biatlon scores</Link></MenuItem> */}
        {/* <MenuItem onClick={handleClose}><Link className="classes.link" to="/Speelschema">Speelschema</Link></MenuItem> */}
        {/* <MenuItem onClick={handleClose}><Link className="classes.link" to="/Ranglijst5Pins">Ranglijst 5Pins</Link></MenuItem> */}
        {/* <MenuItem onClick={handleClose}><Link className="classes.link" to="/RanglijstBiatlon">Ranglijst Biatlon</Link></MenuItem> */}

        
        {/* <MenuItem onClick={handleClose}><a href='/Speelschema'>Speelschema</a></MenuItem> */}
      </Menu>
        </Toolbar>
        </AppBar>
        <div align="left" backgroundColor="black">
        {/* <Link className="classes.link" id="scscreenshot" style={{color: "white"}} to="/StandScreenshot">S</Link> */}
       
        <Link className="sc3BandenThuis1" id="sc3BandenThuis1" style={{color: "white"}} exact to="/StandScreenshot3BT1">3BT1</Link>
        <Link className="scDins_av1" id="scDins_av1" style={{color: "white"}} exact to="/DA1" >1a</Link>
        <Link className="scDins_av2" id="scDins_av2" style={{color: "white"}} exact to="/DA2">2b</Link>

        
        
        {/* <Link className="scMaan_av1" id="scMaan_av1" style={{color: "white"}} exact to="/MA1" >1f</Link>
        <Link className="scMaan_av2" id="scMaan_av2" style={{color: "white"}} exact to="/StandScreenshotMA2">2a</Link>
        <Link className="scMaan_av3" id="scMaan_av3" style={{color: "white"}} exact to="/StandScreenshotMA3">3a</Link>
        <Link className="scMaan_av4" id="scMaan_av4" style={{color: "white"}} exact to="/StandScreenshotMA4">4a</Link>
        <Link className="scDins_av_3B_groot1" id="scDins_av_3B_groot1" style={{color: "white"}} exact to="/StandScreenshotDA3Bg1">1c</Link>
        <Link className="scDins_av_3B_klein1" id="scDins_av_3B_klein1" style={{color: "white"}} exact to="/StandScreenshotDA3Bk1">1b</Link>
        <Link className="scDins_av_3B_klein2" id="scDins_av_3B_klein2" style={{color: "white"}} exact to="/StandScreenshotDA3Bk2">2c</Link>
        <Link className="scDins_av_3B_groot2" id="scDins_av_3B_groot2" style={{color: "white"}} exact to="/StandScreenshotDA3Bg2">2d</Link>
       
       
       
        <Link className="scDins_av3" id="scDins_av3" style={{color: "white"}} exact to="/StandScreenshotDA3">3b</Link>
        <Link className="scDins_av_3B_klein3" id="scDins_av_3B_klein3" style={{color: "white"}} exact to="/StandScreenshotDA3Bk3">3c</Link>
     
        <Link className="scDins_av_3B_groot3" id="scDins_av_3B_groot3" style={{color: "white"}} exact to="/StandScreenshotDA3Bg3">3d</Link>
        <Link className="scDins_av4" id="scDins_av4" style={{color: "white"}} exact to="/StandScreenshotDA4">4b</Link>
        <Link className="scDins_av_3B_groot4" id="scDins_av_3B_groot4" style={{color: "white"}} exact to="/StandScreenshotDA3Bg4">4d</Link>
        <Link className="scDins_av_3B_klein4" id="scDins_av_3B_klein4" style={{color: "white"}} exact to="/StandScreenshotDA3Bk4">4c</Link> 
             
        <Link className="scWoens_av_3B_groot1" id="scWoens_av_3B_groot1" style={{color: "white"}} exact to="/StandScreenshotWA3Bg1">1e</Link>
        <Link className="scWoens_av_3B_groot4" id="scWoens_av_3B_groot4" style={{color: "white"}} exact to="/StandScreenshotWA3Bg4">4e</Link>
        <Link className="scWoens_av_3B_groot2" id="scWoens_av_3B_groot2" style={{color: "white"}} to="/WA3Bg2" >2f</Link>
        <Link className="scWoens_av_3B_groot3" id="scWoens_av_3B_groot3" style={{color: "white"}} exact to="/StandScreenshotWA3Bg3">3e</Link>  
        <Link className="scWoens_av1" id="scWoens_av1" style={{color: "white"}} exact to="/StandScreenshotWA1">1d</Link>
        <Link className="scWoens_av2" id="scWoens_av2" style={{color: "white"}} exact to="/StandScreenshotWA2">2e</Link>
        <Link className="scWoens_av3" id="scWoens_av3" style={{color: "white"}} exact to="/StandScreenshotWA3">3d</Link>
        <Link className="scWoens_av4" id="scWoens_av4" style={{color: "white"}} exact to="/StandScreenshotWA4">4e</Link> */}
     
        
     
        {/* <Link className="classes.link" id="scscreenshot" style={{color: "white"}} to="/StandScreenshot">S</Link> */}
     
        <Route
                path="/testlinks"
                component={testlinks}
                name="testlink"/>
       <Route
                path="/Stand5Pins"
                component={Standloader5Pins}
                name="Standloader5Pins"
              />
               <Route
                path="/Stand5Pinszonderwedstrijden"
                component={Standloader5Pinszonderwedstrijden}
                name="Standloader5Pins"
              />
              <Route
                path="/StandBiatlon"
                component={StandloaderBiatlon}
                name="StandloaderBiatlon"
              />
                <Route
                path="/Speelschema"
                component={Speelschema}
                name="Speelschema"
              />
                <Route
                path="/Ranglijst5Pins"
                component={Ranglijst5Pins}
                name="Ranglijst5Pins"
              />
               <Route
                path="/RanglijstBiatlon"
                component={RanglijstBiatlon}
                name="RanglijstBiatlon"
              />
            
               <Route 
                path="/"
                // component={ScoreboardLoader}
                // name="Scoreboardloader"
                component={StandloaderBiatlon}
                name="StandloaderBiatlon"
              />
               {/* <Route exact
                path="/"
                component={Eindetoernooi}
                name="Eindetoernooi"
              /> */}
     </div>
     
     <Switch>
          <Route strict exact path="/StandScreenshot3BT1">
              <Stand avond="3bandenthuis" competitieronde = "1" />
          </Route>

          <Route exact path="/DA1">
              <Stand avond="dinsdagavond" competitieronde = "1" />
          </Route>
          <Route exact path="/MA1">
              <Stand avond="maandagavond" competitieronde = "1" />
          </Route>
          <Route exact path="/StandScreenshotWA1">
              <Stand avond="woensdagavond" competitieronde = "1" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bk1">
              <Stand avond="dinsdagavond3bklein" competitieronde = "1" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bg1">
              <Stand avond="dinsdagavond3bgroot" competitieronde = "1" />
          </Route>
          <Route exact path="/StandScreenshotWA3Bg1">
              <Stand avond="woensdagavond3bgroot" competitieronde = "1" />
          </Route>
          
          <Route exact path="/DA2">
              <Stand avond="dinsdagavond" competitieronde = "2" />
          </Route>
          <Route exact strict = {false} path="/StandScreenshotMA2">
              <Stand avond="maandagavond" competitieronde = "2" />
          </Route>
          <Route exact path="/StandScreenshotWA2">
              <Stand avond="woensdagavond" competitieronde = "2" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bk2">
              <Stand avond="dinsdagavond3bklein" competitieronde = "2" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bg2">
              <Stand avond="dinsdagavond3bgroot" competitieronde = "2" />
          </Route>
          <Route exact strict path="/WA3Bg2">
              <Stand avond="woensdagavond3bgroot" competitieronde = "2" />
          </Route>

          <Route exact path="/StandScreenshotDA3">
              <Stand avond="dinsdagavond" competitieronde = "3" />
          </Route>
          <Route exact path="/StandScreenshotMA3">
              <Stand avond="maandagavond" competitieronde = "3" />
          </Route>
          <Route exact path="/StandScreenshotWA3">
              <Stand avond="woensdagavond" competitieronde = "3" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bk3">
              <Stand avond="dinsdagavond3bklein" competitieronde = "3" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bg3">
              <Stand avond="dinsdagavond3bgroot" competitieronde = "3" />
          </Route>
          <Route exact path="/StandScreenshotWA3Bg3">
              <Stand avond="woensdagavond3bgroot" competitieronde = "3" />
          </Route>

          <Route exact path="/StandScreenshotDA4">
              <Stand avond="dinsdagavond" competitieronde = "4" />
          </Route>
          <Route exact path="/StandScreenshotMA4">
              <Stand avond="maandagavond" competitieronde = "4" />
          </Route>
          <Route exact path="/StandScreenshotWA4">
              <Stand avond="woensdagavond" competitieronde = "4" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bk4">
              <Stand avond="dinsdagavond3bklein" competitieronde = "4" />
          </Route>
          <Route exact path="/StandScreenshotDA3Bg4">
              <Stand avond="dinsdagavond3bgroot" competitieronde = "4" />
          </Route>
          <Route exact path="/StandScreenshotWA3Bg4">
              <Stand avond="woensdagavond3bgroot" competitieronde = "4" />
          </Route>
          </Switch>
    </Router>
   
   </div>
  );
}

export default App;
